import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "ImportStatus/";

export default class {

  static getImportStatus(id) {
    const url = `${config.uploadUrl + route}GetImportStatus`;
    return http({
      url,
      method: "GET",
      params: { id },
    })
      .then(data => data)
      .catch(error => error);
  }

  // TODO: Support pagination
  /** Returns import history for the given time period */
  static getImportHistory(from, to) {

    let url = `${config.uploadUrl + route}GetImportHistory`;

    return http({
        url,
        method: "GET",
        params: {
          from: DateTime.toISOstring(from),
          to: DateTime.toISOstring(to) 
        },
      })
      .then(data => data)
      .catch(error => error);

  }

  static getLatestImport(masterRuleId) {

    let url = `${config.uploadUrl + route}GetLatestImport`;

    return http({
        url,
        method: "GET",
        params: {
          masterRuleId
        },
      })
      .then(data => data)
      .catch(error => error);

  }
}




// WEBPACK FOOTER //
// ./src/services/importStatus.js